/**
 * WordPress dependencies
 */
import { login as icon } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import edit from './edit';
const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/loginout",
  title: "Login/out",
  category: "theme",
  description: "Show login & logout links.",
  keywords: ["login", "logout", "form"],
  textdomain: "default",
  attributes: {
    displayLoginAsForm: {
      type: "boolean",
      "default": false
    },
    redirectToCurrent: {
      type: "boolean",
      "default": true
    }
  },
  supports: {
    className: true,
    typography: {
      fontSize: false
    }
  }
};
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon,
  edit
};
//# sourceMappingURL=index.js.map